/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
import { useEffect, useState } from 'react';

export const dayLabelIt = (d) =>
  d.toLocaleDateString('it', { weekday: 'long', day: 'numeric', month: 'long' });
export const timeLabelIt = (d) => d.toLocaleTimeString('it', { hour: '2-digit', minute: '2-digit' });

export const SLOT_MINUTES = 30;
export const JOIN_WINDOW_MIN = 10;   // can join up to N minutes before start
export const HERO_LOOKAHEAD_DAYS = 7; // only show visits within this window

export const URGENCY_META = {
  routine: { cls: 'bg-primary/15 text-primary', label: 'Consulto standard' },
  urgent: { cls: 'bg-amber-500/15 text-amber-600', label: 'Urgente' },
  emergency: { cls: 'bg-red-500/15 text-red-600', label: 'Emergenza' },
};

/** Prossima visita valida entro l'orizzonte (in corso o futura), oppure null. */
export const pickNextAppointment = (appointments) => {
  const now = Date.now();
  const horizon = now + HERO_LOOKAHEAD_DAYS * 24 * 3600 * 1000;
  return appointments
    .filter((a) => a && a.status !== 'cancelled' && a.status !== 'completed' && a.scheduled_at)
    .map((a) => ({ ...a, _dt: new Date(a.scheduled_at).getTime() }))
    .filter((a) => !isNaN(a._dt))
    .filter((a) => a._dt + SLOT_MINUTES * 60_000 >= now && a._dt <= horizon)
    .sort((a, b) => a._dt - b._dt)[0] || null;
};

export const useCountdown = (target) => {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const iv = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(iv);
  }, []);
  if (!target) return null;
  const diff = target - now;
  return {
    ms: diff,
    days: Math.floor(diff / (24 * 3600_000)),
    hours: Math.floor((diff % (24 * 3600_000)) / 3600_000),
    minutes: Math.floor((diff % 3600_000) / 60_000),
    seconds: Math.floor((diff % 60_000) / 1000),
    past: diff <= 0,
    inWindow: diff <= JOIN_WINDOW_MIN * 60_000,
  };
};

/** Apre il wizard di prenotazione via evento globale; fallback: scroll al marketplace. */
export const openBookingOrScroll = () => {
  let handled = false;
  const evt = new CustomEvent('sanitanexus:open-booking', { detail: { onHandled: () => { handled = true; } } });
  document.dispatchEvent(evt);
  setTimeout(() => {
    if (!handled) {
      document.querySelector('[data-testid="patient-marketplace"]')?.scrollIntoView({ behavior: 'smooth' });
    }
  }, 120);
};
